// USA Fresh Finds — theme.js
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  initVariantPicker();
});

// Keeps the hidden "id" input, price, image and buttons in sync with the
// visual swatch buttons for each option. Without this, the form always
// submitted the variant that was selected on page load, no matter what
// the shopper clicked.
function initVariantPicker() {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantsEl = document.querySelector('[data-product-variants]');
  var groups = form.querySelectorAll('[data-variant-option]');
  if (!variantsEl || groups.length === 0) return;

  var variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (e) {
    return;
  }

  var hiddenId = form.querySelector('[data-selected-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var comparePriceEl = document.querySelector('[data-compare-price]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var buyBtn = form.querySelector('[data-buy-now]');
  var mainImage = document.getElementById('ProductMainImage');

  function selectedOptionValues() {
    var values = [];
    groups.forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-position'), 10) - 1;
      var active = group.querySelector('.variant-swatch.is-selected');
      values[position] = active ? active.getAttribute('data-variant-value') : null;
    });
    return values;
  }

  function findMatchingVariant() {
    var selected = selectedOptionValues();
    return variants.find(function (variant) {
      return variant.options.every(function (value, i) { return value === selected[i]; });
    });
  }

  // Greys out option values that don't exist for the article's current
  // selection — e.g. once a color is picked, only the sizes that actually
  // come in that color stay selectable, instead of showing every size for
  // every product regardless of what was chosen.
  function updateOptionAvailability(changedGroup) {
    var selected = selectedOptionValues();

    groups.forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-position'), 10) - 1;
      if (group === changedGroup) return;

      group.querySelectorAll('.variant-swatch').forEach(function (btn) {
        var hypothetical = selected.slice();
        hypothetical[position] = btn.getAttribute('data-variant-value');
        var matches = variants.some(function (variant) {
          return variant.options.every(function (value, i) { return value === hypothetical[i]; });
        });
        btn.disabled = !matches;
        btn.classList.toggle('is-unavailable', !matches);
      });
    });
  }

  function updateUI(changedGroup) {
    updateOptionAvailability(changedGroup);

    var variant = findMatchingVariant();

    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      if (buyBtn) buyBtn.style.display = 'none';
      return;
    }

    if (hiddenId) hiddenId.value = variant.id;

    if (priceEl) priceEl.textContent = variant.price;
    if (comparePriceEl) {
      if (variant.compare_at_price) {
        comparePriceEl.textContent = variant.compare_at_price;
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    if (buyBtn) buyBtn.style.display = variant.available ? '' : 'none';

    if (mainImage && variant.image) mainImage.src = variant.image;
  }

  groups.forEach(function (group) {
    var labelValueEl = group.parentElement.querySelector('[data-option-selected-value]');
    var hiddenSelect = form.querySelector(
      '[data-variant-option-select][data-option-position="' + group.getAttribute('data-option-position') + '"]'
    );

    group.querySelectorAll('.variant-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        group.querySelectorAll('.variant-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (labelValueEl) labelValueEl.textContent = btn.getAttribute('data-variant-value');
        if (hiddenSelect) hiddenSelect.value = btn.getAttribute('data-variant-value');
        updateUI(group);
      });
    });
  });

  updateUI();
}
